if (!Array.prototype.at) {
  Array.prototype.at = function <T>(this: T[], index: number): T | undefined {
    if (this == null) {
      throw new TypeError("Array.prototype.at called on null or undefined")
    }

    const len = this.length >>> 0
    let relativeIndex = Number(index)

    if (isNaN(relativeIndex)) {
      relativeIndex = 0
    }

    if (relativeIndex < 0) {
      relativeIndex += len
    }

    if (relativeIndex < 0 || relativeIndex >= len) {
      return undefined
    }

    return this[relativeIndex]
  }
}
